<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label">Name</div>
      </div>
      <div class="group stream-data">
        <input
          matInput
          autocomplete="off"
          type="text"
          class="input-data"
          name="testName"
          #testNameInput="ngModel"
          [(ngModel)]="testName"
          (ngModelChange)="nameUpdated()"
          maxlength="80"
          required
        />
        <div
          class="error"
          *ngIf="testNameInput.invalid && (testNameInput.dirty || testNameInput.touched)"
        >
          <mat-error *ngIf="testNameInput?.errors?.required">Name is required</mat-error>
          <mat-error *ngIf="testNameInput.errors.regex && !testNameInput.errors.required"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">Schedule</div>
      <div class="scheduler-section">
        <!--  -->
        <div class="section-data">
          <div class="group start-input">
            <div class="label">Starts</div>
            <input
              matInput
              autocomplete="off"
              type="text"
              class="input-data disabled"
              [(ngModel)]="startScheduleVal"
              disabled
            />
          </div>
          <div class="group repeat-DD">
            <div class="label">Repeats</div>
            <mat-select
              class="option-list disabled"
              #repeatScheduleValInput="ngModel"
              name="repeatScheduleVal"
              [(ngModel)]="repeatScheduleVal"
              disabled
            >
              <mat-option value="1min">Every 1 minute</mat-option>
            </mat-select>
          </div>
          <div class="group repeat-DD">
            <div class="label">Ends</div>
            <mat-select
              class="option-list"
              [ngClass]="{ disabled: editMode }"
              #endScheduleValInput="ngModel"
              name="endScheduleVal"
              (ngModelChange)="onEndScheduleValChange($event)"
              [(ngModel)]="endScheduleVal"
              [disabled]="editMode"
              required
            >
              <mat-option *ngIf="!isDisabledScheduler" value="on-going"> Never </mat-option>
              <mat-option value="on-demand"> In 8 hours</mat-option>
            </mat-select>
          </div>
        </div>
        <!--  -->

        <!--  <viavi-scheduler></viavi-scheduler> -->
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">Agent & App</div>
      <div>
        <nrwl-agent-picker
          [testType]="testType"
          [originatorDevice]="selectedOriginator"
          [editMode]="editMode"
          [originatorMultiSelection]="true"
          [testMode]="testMode"
          [showTestMode]="false"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
      </div>
      <div class="icon">
        <i class="mdi mdi-ray-start-vertex-end separator-icon"></i>
      </div>
      <div class="app-container">
        <div [ngClass]="{ appDisabled: editMode }">
          <div class="destination">Destination</div>
          <div class="select-app">
            <viavi-common-dropdown
              [dropDownData]="appDropDown"
              [configuration]="dropdownConfiguration"
              (valueChange)="applicationSelection($event)"
              [defaultSelection]="selectedApp"
              *ngIf="appDropDown && appDropDown.length > 0 && dropdownConfiguration"
              [isCustomDropdown]="true"
            ></viavi-common-dropdown>
            <div class="reset-app" *ngIf="showReset" (click)="resetApp()">
              <i class="mdi mdi-plus"></i>
              <span class="link-text">Reset application</span>
            </div>
          </div>

          <div
            class="add-app"
            *ngIf="!addNewApplication && !newAppAssigned && !editMode && hasReadWriteRole"
            (click)="addNewApp()"
          >
            <i class="mdi mdi-plus"></i>
            <span class="link-text">Add new application</span>
          </div>
          <ng-container *ngIf="addNewApplication">
            <add-application
              (applicationAdded)="assignApp($event)"
              [selApp]="selectedApp"
              (closeWindow)="closeAddApplicationWindow($event)"
            ></add-application>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Threshold</b></div>
        <span class="sub-text">(Availability)</span>
      </div>
      <div class="group stream-data">
        <div class="section-data">
           <div class="group threshold-input">
            <div class="label">Warning (%)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data"
              name="thresholdForWarning"
              [(ngModel)]="thresholdForWarning"
              (ngModelChange)="onChangeThreshold()"
              #thresholdForWarningInput="ngModel"
              [min]="warningThersholds.min"
              [max]="warningThersholds.max"
              required
            />
            <mat-error *ngIf="thresholdForWarningInput?.errors?.required"> Required</mat-error>
            <mat-error *ngIf="thresholdForWarningInput.errors?.min || thresholdForWarningInput.errors?.max">
              value should be {{warningThersholds.min}} to {{ warningThersholds.max }}
            </mat-error>
          </div>
           <div class="group threshold-input">
            <div class="label">Critical (%)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data"
              name="thresholdForCritical"
              [(ngModel)]="thresholdForCritical"
              (ngModelChange)="onChangeThreshold()"
              #thresholdForCriticalInput="ngModel"
              [min]="criticalThersholds.min"
              [max]="criticalThersholds.max"
              required
            />
            <mat-error *ngIf="thresholdForCriticalInput?.errors?.required"> Required</mat-error>
            <mat-error *ngIf="thresholdForCriticalInput.errors?.min || thresholdForCriticalInput.errors?.max">
              value should be {{criticalThersholds.min}} to {{ criticalThersholds.max }}
            </mat-error>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
